import React from "react";
import { FaAngleLeft } from "react-icons/fa6";
import { IoNotifications } from "react-icons/io5";
import { useSelector } from "react-redux";

interface HeaderProps {
  toggleSideNav: () => void;
  isSideNavOpen: boolean;
}

const Header = ({ toggleSideNav, isSideNavOpen }: HeaderProps) => {
  const companyData = useSelector((state: any) => state?.company?.companyData);
  return (
    <div className="bg-primary p-4 flex flex-col lg:flex-row gap-5 lg:gap-0 items-center justify-between w-full">
      <div
        className={
          "flex items-center justify-start gap-4 lg:justify-center w-full lg:w-auto"
        }
      >
        <div className={"border border-[#5f6e85] p-1 rounded"}>
          <FaAngleLeft
            className={`text-[#5f6e85] cursor-pointer text-xs ${
              isSideNavOpen ? "" : "rotate-180"
            }`}
            onClick={toggleSideNav}
          />
        </div>
        <div className={"flex items-center text-white"}>
          <div className={"text-sidebarSelectText font-bold text-xl lg:text-2xl"}>
            {companyData?.name}
          </div>
          {/* <div className={"text-primaryText font-bold text-xl lg:text-2xl"}>
            &nbsp;- Distracted Driving Program
          </div> */}
        </div>
      </div>
      <div className={"flex items-center justify-between gap-4 w-full lg:w-auto"}>
        <div className={"flex items-center gap-4"}>
          <div
            className={
              "border border-grayBorder py-1 px-3 lg:py-1.5 rounded-full text-primaryText flex items-center font-medium text-base lg:text-lg gap-2"
            }
          >
            <p className={"text-green !font-bold"}>{companyData?.live_saved}</p>{" "}
            Lives Saved
          </div>
          <div
            className={
              "border border-grayBorder py-1 px-3 lg:py-1.5 rounded-full text-primaryText flex items-center font-medium text-base lg:text-lg gap-2"
            }
          >
            <p className={"text-sidebarSelectText !font-bold"}>
              {companyData?.crashes_prevented}
            </p>{" "}
            Incidents Prevented
          </div>
        </div>
        <div className={"flex items-center gap-2 lg:gap-4"}>
          <div className={"border border-grayBorder rounded-full p-2 lg:p-3"}>
            <IoNotifications className={"text-grayIcon"} />
          </div>
          <div className={"border border-grayBorder rounded-full"}>
            <img src={"/User.png"} alt="" width={"42px"} height={"42px"} className={"h-[34px] w-[34px] lg:h-[42px] lg:w-[42px]"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
